import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "dashboard(/:sectionId)",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "behaviour-dashboard" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [],
});
